import React from "react";

import style from "../index.module.scss";

const AdjustIcon = () => (
  <span className={style.align_icon}>
    <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" enableBackground="new 0 0 409.6 409.6" version="1.1" viewBox="0 0 409.6 409.6" xmlSpace="preserve">
      <path fill="currentColor" d="M392.533 187.733H17.067C7.641 187.733 0 195.374 0 204.8s7.641 17.067 17.067 17.067h375.467c9.426 0 17.067-7.641 17.067-17.067s-7.642-17.067-17.068-17.067z" transform="rotate(90 205 205)" />
    </svg>
  </span>
);

export default AdjustIcon;
